import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  contentContainer: {
    margin: '2rem auto 6rem',
    maxWidth: 832,
    padding: theme.spacing(0, 2),
  },
  stack: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
  },
  card: {
    border: '1px solid #E0E0E0',
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    overflow: 'hidden',
  },
  cardHeader: {
    padding: theme.spacing(2.5, 3, 2),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2, 2, 1.5),
    },
  },
  cardTitle: {
    fontWeight: 700,
    fontSize: '1.125rem',
    lineHeight: 1.3,
    color: '#00205B',
  },
  cardDivider: {
    height: 1,
    backgroundColor: '#E0E0E0',
  },
  cardContent: {
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
      gap: theme.spacing(2),
    },
  },
  summaryGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: theme.spacing(2),
    },
  },
  summaryField: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  summaryLabel: {
    fontSize: '0.6875rem',
    fontWeight: 600,
    letterSpacing: '0.08em',
    lineHeight: 1.3,
    color: '#6B7C87',
    textTransform: 'uppercase',
  },
  summaryValueRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    minWidth: 0,
  },
  summaryIconWrap: {
    width: 40,
    height: 40,
    borderRadius: '50%',
    backgroundColor: '#E0EAFF',
    color: '#001C57',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  summaryIcon: {
    fontSize: '1.25rem',
  },
  summaryValue: {
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 1.4,
    color: '#172024',
  },
  summarySecondary: {
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: '#6B7C87',
    marginTop: theme.spacing(0.25),
  },
  lastUpdatedRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: '#6B7C87',
  },
  lastUpdatedIcon: {
    fontSize: '1rem',
    color: '#6B7C87',
  },
  feeSection: {
    display: 'flex',
    flexDirection: 'column',
  },
  feesBody: {
    display: 'flex',
    flexDirection: 'column',
    '& > $feeRow:last-child': {
      borderBottom: 'none',
    },
  },
  feeRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    minHeight: 44,
    padding: theme.spacing(1.25, 0),
    borderBottom: '1px solid #E0E0E0',
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 1.4,
    color: '#172024',
    '& .MuiTypography-root': {
      color: 'inherit',
      fontSize: 'inherit',
      fontWeight: 'inherit',
      lineHeight: 'inherit',
    },
  },
  feeRowBold: {
    fontWeight: 700,
  },
  recordRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(1.25, 2.5),
    borderRadius: 999,
    backgroundColor: '#F3F3F3',
    fontSize: '0.875rem',
    lineHeight: 1.4,
    color: '#172024',
  },
  recordRowPrimary: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    minWidth: 0,
    flexWrap: 'wrap',
  },
  recordDate: {
    fontSize: '0.875rem',
    fontWeight: 700,
    lineHeight: 1.4,
    color: '#172024',
  },
  recordAmount: {
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.4,
    color: '#6B7C87',
  },
  recordType: {
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.4,
    color: '#6B7C87',
    flexShrink: 0,
  },
  recordStack: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  recordRefundReason: {
    fontSize: '0.8125rem',
    color: '#6B7C87',
    marginTop: theme.spacing(0.5),
  },
  receiptLink: {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.875rem',
    color: '#00205B',
    padding: theme.spacing(0.5, 1),
    '& .MuiButton-startIcon': {
      marginRight: theme.spacing(0.75),
    },
  },
  refundCard: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(2.5, 3),
    border: '1px solid #E0E0E0',
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: theme.spacing(2),
    },
  },
  refundCopy: {
    minWidth: 0,
  },
  refundTitle: {
    fontWeight: 700,
    fontSize: '1rem',
    lineHeight: 1.3,
    color: '#00205B',
    marginBottom: theme.spacing(0.5),
  },
  refundCaption: {
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: '#6B7C87',
  },
  refundButton: {
    flexShrink: 0,
    textTransform: 'uppercase',
    fontWeight: 600,
    letterSpacing: '0.04em',
    borderRadius: 999,
    padding: theme.spacing(1, 2.5),
    '& .MuiButton-startIcon': {
      marginRight: theme.spacing(0.75),
    },
  },
  refundButtonIcon: {
    fontSize: '1.125rem',
  },
  messageCoachButton: {
    flexShrink: 0,
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 999,
    padding: theme.spacing(1, 2.5),
    '& .MuiButton-startIcon': {
      marginRight: theme.spacing(0.75),
    },
  },
  messageCoachButtonIcon: {
    fontSize: '1.125rem',
  },
}))
